module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("Early Judaism")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("New Insights and Scholarship")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Edited by Frederick E. Greenspahn")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "44",
      "src": "images/NYU_TitlePage_Logo.jpg",
      "width": "35"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168ddb6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/greenspahnEarly-0004.vue
// module id = 63
// module chunks = 0